export default "__VITE_ASSET__DHKZPbtj__"